import type { OrderItem, Product } from "@jti/magento";
import type { CommerceEventItem } from "@jti/tracker";

const NO_VALUE = "N/A";
const CARTON_FORMAT = ["Pack", "Mix and Match", "Carton"];

export const isSubscriptionProduct = ({ subscription }: Product | OrderItem) => subscription === 1;

export const isCartonProduct = ({ subscription_format }: Product | OrderItem) =>
  subscription_format && CARTON_FORMAT.includes(subscription_format);

export const mapProductToCommerceEventItem = (product: Product | OrderItem, index: number): CommerceEventItem => {
  const { price, name, sku, quantity } = product;
  const discount = product.price_range?.maximum_price?.discount?.percent_off;

  let itemPrice = price;
  if ("productSalePrice" in product && product.productSalePrice !== undefined && product.productSalePrice !== null) {
    itemPrice = product.productSalePrice;
  }

  const isSubscriptionItem = isSubscriptionProduct(product);
  const isCartonItem = isCartonProduct(product);

  return {
    index: Number(index),
    currency: price.currency,
    item_category: product.categories ? product.categories[0]?.name : NO_VALUE,
    item_category2: product.categories ? product.categories[1]?.name : NO_VALUE,
    item_color: product.color_label?.toLowerCase() ?? NO_VALUE,
    item_flavor: String(product.flavor ?? NO_VALUE),
    item_name: name,
    item_sku: sku,
    item_list_name: product.categories ? `${product.categories[0]?.name} > ${product.categories[1]?.name}` : NO_VALUE,
    item_list_id: product.categories ? `${product.categories[0]?.name} > ${product.categories[1]?.name}` : NO_VALUE,
    price: Number(itemPrice.value),
    quantity: Number(quantity),
    discount: discount ?? 0,
    /*
        We need to ensure consistent item_id value throughout checkout process for tracking pursposes
        the best candidate to preserve consistency in this case seems to be SKU code
        https://jira.jtiweb.co.uk/browse/DESP-91609
      */
    item_id: sku || name,
    item_brand: "ploom",
    item_coupon: NO_VALUE,
    item_coupon_type: NO_VALUE,
    item_strength: NO_VALUE,
    item_rewards: NO_VALUE,
    purchase_type: isSubscriptionItem ? "subscription" : "one-time",
    carton_format: product?.subscription_format ?? NO_VALUE,
    carton_quantity: isCartonItem ? quantity : NO_VALUE,
  };
};
